import { render, staticRenderFns } from "./ViewRevaluation.vue?vue&type=template&id=0b0f4da2"
import script from "./ViewRevaluation.vue?vue&type=script&lang=js"
export * from "./ViewRevaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports